import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { PrincipalinventoryService } from "../../../services/principalinventory.service";
import { LocationService } from "../../../services/location.service";
import { SecurazeService } from "../../../services/securaze.service";
import { TicketsService } from "../../../services/tickets.service";
import { Methods } from "../../../shared/methods";
import { ContainerCrudComponent } from "../../../shared/components/containerCrud/containerCrud.component";
import { Inventory } from "../../../models/inventory";
import { Countries } from '../../../models/countries';
import { RemoveHardDrivesComponent } from '../remove-hard-drives/remove-hard-drives.component';
import { MobilesdevicesService } from "../../../services/mobilesdevices.service"
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

declare const $: any;

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit {

  public mtds: Methods = new Methods();
  public id;
  public loading = false;

  public identity;
  public token;

  public countries: Array<any> = [];
  public userLocations: Array<any> = [];
  public conditions: Array<any> = [];
  public loadingContainers = false;
  public loadingVirtualContainers = false;
  public containers = [];
  public virtualContainers = [];
  public inventory: Inventory = new Inventory();
  public containerName;
  public Editor = ClassicEditor;
  public lastpage = 'inventory';
  public type = 'Inventory';

  public matchSerialNumber = '';

  public logs: Array<any> = [];
  public logHistory: boolean = false;

  public itemType;

  public systemComments: string = '';
  public phonecheckshow = false
  constructor(
    private _service: PrincipalinventoryService,
    private _locationService: LocationService,
    private _securazeService: SecurazeService,
    private _ticketsService: TicketsService,
    private _router: Router,
    private _route: ActivatedRoute,
    public dialog: MatDialog,
    private mobilesdevicesService: MobilesdevicesService
  ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.token = JSON.parse(localStorage.getItem("token"));

    let countries: Countries = new Countries();
    this.countries = countries.countries;
  }

  ngOnInit() {
    this._route.params.subscribe(params => {
      console.log(params);
      this.id = params['id'];
      if (params['type'] === 'history') {
        this.lastpage = 'inventoryhistory';
        this.type = 'history';
      }
      this.loading = true;
      this.getLocations();
      this.getInventory(this.type);
      this.getConditions();
      this.getContainers();
      this.getVirtualContainers();

      //if(this.type !== 'history')
        this.getAttributes();
    });

    console.log(this.lastpage);
  }

  back () {
    this._router.navigate(['/' + this.lastpage]);
  }

  public showAttributes = false;
  public partial = 0;
  public failed = 0;
  public passed = 0;
  public destroyed = 0;
  public removed = 0;
  public diskDrives;

  getAttributes(){

/*     let type;

    if(this.type === 'history')
      type = 'history';
    else
      type = 'inventory'; */
      let typed = "";
      if(this.lastpage === "inventory"){
       typed = "inventory";
      }else{
       typed = "history";
      }

    this._service.getAttributes(this.id, typed).subscribe(
      response => {

        this.partial = 0;
        this.failed = 0;
        this.passed = 0;
        this.destroyed = 0;
        this.removed = 0;

        console.log(response);

        if(response.status === 'success'){

          this.diskDrives = response.data.hdds;

          for (let element of response.data.hdds) {

            if(element.hddErasureresults === 'PARTIAL')
              this.partial = this.partial + 1;

            if(element.hddErasureresults === 'FAILED')
              this.failed = this.failed + 1;

            if(element.hddErasureresults === 'PASSED')
              this.passed = this.passed + 1;

            if(element.hddErasureresults === 'DESTROYED')
              this.destroyed = this.destroyed + 1;

            if(element.hddErasureresults === 'REMOVED')
              this.removed = this.removed + 1;
          }

          this.showAttributes = true;

        }

      }, error => {
        /* console.log("error"); */
      }

    );
  }

  showLogHistory(){
    this.logHistory = !this.logHistory;
  }

  modalSN(){
    $("#modalSerialMatch").modal("show");
  }

  matchSN(){

    this._service.matchSN(this.matchSerialNumber, this.id).subscribe(
      response => {

        if(response.status === 'success'){

          this.mtds.notifySuccess('Match saved successfully');
          
          $('#modalSerialMatch').modal('hide');

          this.getAttributes();

        }else{
          this.mtds.notifyError('Serial Number Not Found');
        }

      }, error => {
        console.log("error");
      }

    );
  }

  removeContainer(){

    let json = {
      container_id: this.inventory.container_id,
    };

    this._ticketsService.removeItemContainer(this.id, json).subscribe(
      (r) => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess('Container inventory has been removed successfully');
          this.getInventory(this.type);
          this.containerName = '';
          this.getContainers();
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  public wharehouseList: Array<any> = [];
  public buscandoWharehouse = true;

  getLocations() {
    this._locationService
      .getLocationsByUser(this.token, this.identity.sub)
      .subscribe((response) => {
        this.userLocations = response.data;
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          this.wharehouseList = response.data;
        } else {
          this.mtds.notifyError('ERROR!', response.msg);
        }
        this.buscandoWharehouse = false;
      });
  }

  removeHardDrives(){
    
    let dialogRef = this.dialog.open(RemoveHardDrivesComponent, {
        width: "90%",
        data: {
          diskdrives: this.diskDrives,
          po: this.inventory.po.po,
          clientsname: this.inventory.po.contactcompany
        },
        disableClose: true,
        autoFocus: false,
        maxHeight: '90vh' //you can adjust the value as per your view
      });

      dialogRef.afterClosed().subscribe((result) => {
        //this.getData();
        this.getAttributes();
      });
  }

  getconditionname() {
    const found = this.conditions.find(element => element.id === this.inventory.condition_id);
    return found.name;
  }

  public editValue: any = null;
  public campo: string = '';
  public title: string = '';

  public editlocation = false;
  public editSN = false;
  public editeWeight = false;
  public editDesc = false;
  public editeEdesc = false;
  public editIC = false;
  public editsoIC = false;
  public editCtoC = false;
  public editCtoV = false;

  restart(all: boolean = false) {
    this.editlocation = false;
    this.editSN = false;
    this.editDesc = false;
    this.editeEdesc = false;
    this.editeWeight = false;
    this.editIC = false;
    this.editsoIC = false;
    this.editCtoC = false;
    this.editCtoV = false;
    if (all) {
      this.title = '';
      this.campo = '';
      this.editValue = null;
    }
  }

  edit(campo: string, valor) {
    console.log('Funcion editar inico:')
    console.log(valor);
    this.campo = campo;
    this.restart();

    switch (campo) {
      case 'condition':

        $('#myModal').modal('show');
        this.editValue = valor;
        break;
      case 'location':
        this.editlocation = true;
        setTimeout(function () {
          $("#el").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'serialnumber':
        this.editSN = true;
        setTimeout(function () {
          $("#esn").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'description':
        this.editDesc = true;
        setTimeout(function () {
          $("#edesc").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'weight':
        this.editeWeight = true;
        setTimeout(function () {
          $("#eweight").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'extendeddescription':
        this.editeEdesc = true;
        setTimeout(function () {
          $("#eEDesc").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'internalComments':
        this.editIC = true;
        setTimeout(function () {
          $("#edIC").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'sointernalcomments':
        this.editsoIC = true;
        setTimeout(function () {
          $("#esoIC").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'commentstocustomer':
        this.editCtoC = true;
        setTimeout(function () {
          $("#ectc").focus();
        }, 50);

        this.editValue = valor;
        break;
      case 'commentstovendor':
        this.editCtoV = true;
        setTimeout(function () {
          $("#ectv").focus();
        }, 50);

        this.editValue = valor;
        break;
      default:
        this.editValue = valor;
        break;
    }
  }

  public saving = false;

  save() {
    
    this.saving = true;
    let json = { field: this.campo, value: this.editValue }
    let typed = "";
    if(this.lastpage === "inventory"){
     typed = "inventory";
    }else{
     typed = "history";
    }
    this._service.especificedit(this.id, json, typed).subscribe(
      r => {
        console.log(r);

        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.code === 404) {
          // this.notFound = true;
        } else if (r.status === 'success') {

          this.getData(r);
          this.mtds.notifySuccess('Changes have been saved successfully');
          $('#myModal').modal('hide');
          this.restart(true);
        } else { this.mtds.notifyError(r.msg, r.code); }
        this.saving = false;
      }, error => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );

  }

  getConditions() {
    this._locationService.getConditions(this.token).subscribe((response) => {
      this.conditions = response.data;
    });
  }

  getContainers() {
    this.loadingContainers = true;
    this._locationService.getContainersInput(this.token).subscribe(
      (r) => {
        console.log(r);
        this.loadingContainers = false;
        this.containers = r.data.map( element => {
          return {
            id: element.id,
            name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation : ''
            }`
            /*name: `${element.id} - ${element.item} - ${
              element.internalLocation !== null ? element.internalLocation.locationName  + ': ' + element.internalLocation.locationRow + ' - ' +
              element.internalLocation.locationBay + ' - ' + element.internalLocation.locationLevel + ' - ' + element.internalLocation.locationSection : ''
            }`*/
          }
        })

        if ( this.containers.findIndex(e => e.id === this.inventory.container_id) === -1) {
          this.containers.push(
            {id: this.inventory.container_id, name: this.containerName }
          )
        }
      }, error => {
        this.loadingContainers = false;
      }
    );
  }

  getVirtualContainers() {
    
    this.loadingVirtualContainers = true;
    this.virtualContainers = [];

    this._securazeService.getContainers(this.token).subscribe(
      response => {

        response.data.forEach(
            function (element) {
              this.virtualContainers.push({
                  id: element.id,
                  name: element.nameVirtualContainer
                });
            }.bind(this)
          );

        this.virtualContainers.sort((a,b) => {
          const n1 = a.name.toLowerCase();
          const n2 = b.name.toLowerCase();

          if (n1 < n2) { return -1; }
          if (n1 > n2) { return 1; }
          return 0;
        });

        /*if(param === 1)
          this.showC = true;*/
        this.loadingVirtualContainers = false;

      }, error => {
        this.loadingVirtualContainers = false;
      }

    );
  }

  testItem(){
    this._service.testItem(this.id).subscribe(
      response => {
        console.log(response);
        if(response.status === 'success'){
          this.inventory.testingStatus = response.data.testingStatus;  
          this.mtds.notifySuccess('Changes have been saved successfully');
        }
      }, error => {
        console.log(error);
      }
    );
  }


  getInventory(type) {
    this._service.showOne(this.id, type).subscribe(
      (r) => {
        console.log(r);
        // console.log(r.data.master.inventoryCategory.name);
        if (r.code === 400 && r.msg === "Authorization not valid") {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (r.status === "success") {
          this.getData(r);
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getData(r) {
    this.inventory = new Inventory(
      r.data.item,
      r.data.mfgr,
      r.data.warehouseTable ? r.data.warehouseTable.id : null,
      r.data.countryOrigin,
      r.data.serialnumber,
      r.data.purchasecost,
      r.data.condition !== null ? r.data.condition.id : null,
      r.data.customerAsset,
      r.data.description,
      r.data.status,
      r.data.extendeddescription,
      r.data.internalComments,
      r.data.commentstovendor,
      r.data.pp || null,
      r.data.po || null,
      r.data.sp || null,
      r.data.so || null,

      r.data.inventoryid,
      [],
      null,
      r.data.quantity,
      r.data.location,
      r.data.idVirtualContainer ? r.data.idVirtualContainer : '',
      null,
      null,
      r.data.weightItem ? r.data.weightItem.id : '',
      null,
      (r.data.master && r.data.master.inventoryCategory) ? r.data.master.inventoryCategory.name :  '',
      r.data.testingStatus,
      r.data.poline,
      r.data.soLine,
      r.data.warehouseTable ? r.data.warehouseTable.name : '',
      r.data.po.po ? `${r.data.po.po} - ${r.data.poline}` : '',
      r.data.datereceived,
      r.data.purchasecost,
      r.data.so ? `${r.data.so.so} - ${r.data.soLine}` : '',
      r.data.receivestatus,
      r.data.weight,
      r.data.systemcomments,
      r.data.so ? r.data.so.internalcomments : '',
      r.data.commentstocustomer,
      r.data.commentstovendor,
      //r.data.reserveduser ? r.data.reserveduser.name[0] + r.data.reserveduser.surname[0] : '',
      r.data.reservedby,
      r.data.datereserved,
      r.data.returnedBy ? r.data.returnedBy.name[0] + r.data.returnedBy.surname[0] : '',
      r.data.dateReturned,
      null,
      r.data.id,
      r.data.nonInventory,
      r.data.unitprice,
      r.data.invoiceddate
    );

    console.log(this.inventory);
    if(this.inventory.serialnumber){
      this.getdatabitraser(this.inventory.serialnumber);
      this.getphonecheck(this.inventory.serialnumber);
    }
    
    // let codigo = new DOMParser();

    // this.inventory.extendeddescription = codigo.parseFromString(this.inventory.extendeddescription, "text/html");
    // console.log(this.inventory.extendeddescription);

    // if (r.data.datereceived) {
    //   this.inventory.dateReceived = String(r.data.datereceived).slice(0, 10);
    //   console.log(this.inventory.dateReceived);
    // }

    //console.log(this.inventory);
    if (r.data.weightItem && r.data.weightItem.enableAsAVirtualContainer !== 1) {
      this.containerName = `${r.data.weightItem.id} - ${r.data.weightItem.item} - ${
        r.data.weightItem.internalLocation !== null ? r.data.weightItem.internalLocation.locationName  + ': ' + r.data.weightItem.internalLocation.locationRow + ' - ' +
        r.data.weightItem.internalLocation.locationBay + ' - ' + r.data.weightItem.internalLocation.locationLevel + ' - ' + r.data.weightItem.internalLocation.locationSection : ''
      }`;
    } else {
      this.containerName = r.data.weightItem ?
      `${r.data.weightItem.id} - ${r.data.weightItem.nameVirtualContainer}` : '';
    }

    this.systemComments = r.data.systemcomments;

    if(this.systemComments !== null)
      this.systemComments = this.systemComments + '\n';

   /*  this.getLogs(); */
    this.getLogsInventory();
  }
 public bitrasershow = false
  getdatabitraser(id){
    this._securazeService.gedatabitraser(this.token, id).subscribe(
      (response) => {
        if(response.status === "success"){
          console.log("datos subidos")
          console.log(response)
          this.bitrasershow = true
        }else{
          this.bitrasershow = false
        }

      },
      (error) => {
        /* console.log(error); */
      }
    );
  }
  getphonecheck(id){
    this.phonecheckshow = false
    this.mobilesdevicesService.Getphonecheckdata(id).subscribe(
      (response) => {
        if(response.status === "success"){
          console.log("datos subidos")
          console.log(response)
          this.phonecheckshow = true
        }else{
          this.phonecheckshow = false
        }

      },
      (error) => {
        /* console.log(error); */
      }
    );
  }
  getLogs() {
    this._service.getLogs(this.id, '').subscribe(
      r => {
        console.log(r);
        if(r.status === 'success'){

          r.data.forEach(
            function (element) {    
              console.log(element);          
              console.log(this.systemComments);
              if(this.systemComments === null)
                this.systemComments = element.createdAt + ' - ' + element.comment + '\n';  
              else
                this.systemComments = this.systemComments + element.createdAt + ' - ' + element.comment + '\n';
            }.bind(this)
          );
          //this.logs = r.data;
          this.systemComments = this.systemComments.trim();
        }
      }
    );
  }
  getLogsInventory(){
     let typed = "";
     if(this.lastpage === "inventory"){
      typed = "Inventory";
     }else{
      typed = "InventoryHistory";
     }

    this._service.getLogsInventory(this.id, '',typed).subscribe(
      r => {
        console.log(r);
        if(r.status === 'success'){

          r.data.forEach(
            function (element) {    
              console.log(element);          
              console.log(this.systemComments);
              if(this.systemComments === null)
                this.systemComments = element.createdAt + ' - ' + element.comment + '\n';  
              else
                this.systemComments = this.systemComments + element.createdAt + ' - ' + element.comment + '\n';
            }.bind(this)
          );
          //this.logs = r.data;
          this.systemComments = this.systemComments.trim();
        }
      }
    );
  }
  public aguante2 = false;

  ChangeWarehouse() {
    $("#changeWarehouse").modal("show");
    this.aguante2 = true;
    setTimeout(
      function () {
        this.aguante2 = false;
      }.bind(this),
      250
    );
  }

  closeChangeWarehouse() {
    $("#changeWarehouse").modal("hide");
  }

  changeWH(e) {
    console.log(e);
    this.inventory.warehouse_id = e.id;
    this.inventory.warehouse_name = e.name;
    this.campo = 'warehouse';
    this.editValue = e.id;
    this.save();
    this.closeChangeWarehouse();
  }

  gotopp(id) {
    window.open('/purchaseproposal/' + id);
  }

  gotopo(id) {
    window.open('/purchase-order/' + id);
  }

  gotosp(id) {
    window.open('/salesproposal/' + id);
  }

  gotoso(id) {
    window.open('/sales-orders/' + id);
  }

  saveContainer(e) {
    console.log(e);
    this.inventory.container_id = e.id;
    const json = {field:"weightitem", value: this.inventory.container_id}

    this._locationService.saveContainers(this.token, this.id, json).subscribe(
      r => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess('Container inventory has been updated successfully');
          this.getInventory(this.type);
        } else {
          this.mtds.notifyError(r.msg);
        }
      }
    );
  }

  saveVirtualContainer(e) {

    this.inventory.idVirtualContainer = e.id;
    const json = {field:"virtual", value: this.inventory.idVirtualContainer}

    this._locationService.saveContainers(this.token, this.id, json).subscribe(
      r => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess('Virtual Container inventory has been updated successfully');
        } else {
          this.mtds.notifyError(r.msg);
        }
      }
    );
  }

  create(isVirtual) {
    let dialogRef = this.dialog.open(ContainerCrudComponent, {
      width: "40%",
      data: { data: "holis", virtual: isVirtual },
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {

      if(result !== undefined){
        this.mtds.notifySuccess('Virtual Container inventory has been updated successfully');

        if(isVirtual === 1)
          this.getVirtualContainers();
        else
          this.getContainers();
      }

    });
  }

  inventoryAttributes(serialnumber){
    this._router.navigate(['/inventory/attributes', serialnumber, this.id, this.type]);  
  }

  public cerrar = 0;
  public weightRequired = 0;

  openItemModal() {
    
    setTimeout(
      () => {
        this.selectType("Inventory");
      },
      250
    );
    $("#lineItemModal").modal("show");
  }

  closeItemModal() {
    $("#lineItemModal").modal("hide");
  }

  selectType(type) {
    this.itemType = type;   
  }

  saveItemMfgr(e) {
    //console.log(e);
    this._service.updateItemMfgr(this.id, e).subscribe(
      r => {
        console.log(r);
        if (r.code === 200) {
          this.mtds.notifySuccess('Inventory has been updated successfully');
          $("#lineItemModal").modal("hide");
          this.getInventory(this.type);
        } else {
          this.mtds.notifyError(r.msg);
        }
      }
    );

  }

  stopPropagation(event: WheelEvent): void {
    event.stopPropagation();
  }

}
